<template>
  <div class="d-flex justify-content-between confirmation__container">
    <div class="d-flex flex-column">
      <div class="confirmation__title heading-h2-24-semi mb-1 mt-5">
        {{$t('downgrade.confirm.heading', { plan: choosedPlanText })}}
      </div>
      <div class="confirmation__description text-dark6 mb-4">
        {{$tc('downgrade.confirm.desc')}}
      </div>
      <div class="confirmation__body">
        <div class="confirmation__billing-interval mb-4">
          <div class="confirmation__section-title mb-2">
            {{$tc('downgrade.confirm.billingInterval.label')}}
          </div>
          <BaseSelect
            className="new-dropdown-select"
            v-model="billingInterval"
            :options="billingIntervals"
            :defaultText="'Search by'"
            :reverseArrow="true"
            @input="setBillingInterval()"
          />
        </div>
        <div class="confirmation__features">
          <div class="confirmation__section-title mb-2">{{$tc('downgrade.confirm.losedFeature.label')}}</div>
          <div class="confirmation__features-body d-flex">
            <div class="confirmation__features-body-left mr-5">
              <LosedFeatureBlock :losedFeature="losedEssentialsFeatures" class="mb-3"/>
              <LosedFeatureBlock :losedFeature="losedSupportFeatures" v-if="isEnterpriseToOptimize"/>
            </div>
            <div class="confirmation__features-body-right d-flex flex-column">
              <LosedFeatureBlock :losedFeature="losedAdvancesFeatures" class="mb-3"/>
              <LosedFeatureBlock :losedFeature="losedSupportFeatures" v-if="!isOptimizeToBuild && !isEnterpriseToOptimize"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SummaryBlock :isYearly="isYearly" :choosedPlan="choosedPlan" :choosedPlanText="choosedPlanText" :planPrice="planPrice"/>
  </div>
</template>

<script>
import LosedFeatureBlock from '../components/LosedFeatureBlock.vue'
import SummaryBlock from '../components/SummaryBlock.vue'
import choosedPlanStatus from "../mixins/choosedPlanStatus";
import initConfirmation from "../mixins/confirmation";

export default {
  name: 'Confirmation',
  components: {
    LosedFeatureBlock,
    SummaryBlock
  },
  mixins: [initConfirmation(), choosedPlanStatus()],
}
</script>

<style lang="scss">
  .confirmation {
    &__container {
      height: 100%;
    }
    &__billing-interval {
      width: 380px;
    }
    &__section-title {
      font-size: 14px;
      line-height: 16px;
      font-weight: 500 !important;
    }
    &__features-body {
      padding: 24px;
      border-radius: 3px;
      border: solid 1px $neutral7;
    }
    &__features-block {
      &-title {
        font-size: 12px;
        font-weight: 600;
        line-height: 18px;
        color: $dark6;
      }
      &-list-item-icon {
        width: 16px;
        height: 16px;
        @include flex-center;
        > .icon {
          color: $accentRed300;
        }
      }
      &-list-item-label {
        font-size: 14px;
        line-height: 22px;
        color: $textLightModeHigh;
      }
    }
  }

  @media screen and (max-width: 1340px) {
    .confirmation__features-body {
      flex-direction: column;
      &-left {
        margin-bottom: 24px;
      }
    }
    .confirmation__billing-interval {
      width: 100%;
    }
  }
</style>
